import { colors } from '../../colors';
var anchor = {
  anchorColor: colors.darkNight
};
export default anchor;